const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnLockXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.231 42.139h-1.037v-2.6a4.378 4.378 0 1 0-8.713 0v2.6h-1.171a1.373 1.373 0 0 0-1.365 1.377v8.949a1.373 1.373 0 0 0 1.365 1.377h10.922a1.372 1.372 0 0 0 1.365-1.377v-8.949a1.372 1.372 0 0 0-1.366-1.377zm-8.386-2.6a3.019 3.019 0 1 1 5.983 0v2.6h-5.983zm8.386 12.931h-10.922v-8.954h10.922z",
    transform: "translate(-892.77 -32.285)",
    style: {
      fill: "current",
      stroke: "#fff",
      strokeWidth: ".4px"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnLockXs);
export default __webpack_public_path__ + "static/media/btn-lock-xs.49a1072dab995c987d6ad83161305865.svg";
export { ForwardRef as ReactComponent };